<template>
  <div class="map">
    <div class="map__wrapper">
      <div class="map__wrapper__title">
        {{ geoArea + " - " + currentSelection }}
      </div>
      <div class="map__wrapper__main">
        <MapLegend :uom="uom" :date="metadatum.dateUpdated" />
        <Map class="map__wrapper__main__map" :mapStyle="mapStyle"></Map>
      </div>
    </div>
    <div class="map__top">
      <Top5Mobile />
    </div>
    <Disclaimer class="map__disclaimer" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Map from "../../widgets/Map.vue";
import getUomAndMetadatum from "../../../mixins/getUomAndMetadatum";
import MapLegend from "./MapLegend.vue";
import Top5Mobile from "./Top5Mobile.vue";
import Disclaimer from "./Disclaimer.vue";

export default {
  name: "MapWrapper",
  mixins: [getUomAndMetadatum],
  components: {
    Map,
    MapLegend,
    Top5Mobile,
    Disclaimer,
  },
  props: {
    fixedText: {
      type: String,
      required: false,
    },
  },
  computed: {
    currentSelection() {
      let res = "";
      if (this.currentSourceConfig) {
        const hasSource = this.currentSourceConfig.sources;
        const hasDataTypes = this.currentSourceConfig.dataTypes;
        if (hasSource && this.source && this.sourceName) {
          res = this.sourceName;
          if (
            this.mainSource.toLowerCase() === "biofuels" &&
            this.source.toLowerCase() === "total"
          ) {
            res = `${this.mainSource} ${this.sourceName}`;
          }
        } else {
          res = this.mainSource;
        }

        if (hasDataTypes && this.dataType) {
          res += ` ${this.dataType}`;
        }
      }
      return this.fixedText + res;
    },
    sourceName() {
      return this.currentSourceConfig.sources.find((x) => x.key === this.source)
        .name;
    },
    ...mapGetters({
      mapStyle: "ui/mapStyle",
      mainSource: "ui/mainSource",
      geoArea: "ui/geoArea",
      currentSourceConfig: "ui/currentSourceConfig",
    }),
  },
};
</script>

<style lang="scss" scoped>
.map {
  background-color: var(--source-color-dark);
  color: $ui-white;

  &__wrapper {
    &__title {
      padding: 4.48vh 4.8vw;
      border-bottom: $white-border-thin;
      @include title-H5;
    }

    &__main {
      position: relative;
    }
  }
}

.tablet {
  .map {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    &__wrapper {
      grid-area: 1 / 1 / 2 / 3;

      &__title {
        height: 4.7vh;
        padding: 1.76vh 0 1vh 5.1vw;
      }
    }

    &__top {
      grid-area: 1 / 3 / 2 / 4;
    }

    &__disclaimer {
      grid-area: 2 / 1 / 3 / 4;
    }
  }
}
</style>
